/**
 * KioskEntry — landing page for kiosk mode.
 * Accessible at /kiosk regardless of auth state.
 * Logs in as kiosk account and redirects to /?kiosk=1.
 */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import api from "../api/api";

export default function KioskEntry() {
  const navigate = useNavigate();
  const { setUser, setIsLoggedIn, applyTheme } = useAuth();

  useEffect(() => {
    (async () => {
      try {
        const res = await api.post("/auth/login", {
          identifier: "kiosk",
          password: "D3m0CardStoard!",
        });
        if (res.data.user) setUser(res.data.user);
        else { const me = await api.get("/auth/me"); setUser(me.data); }
        try { const sr = await api.get("/settings/"); applyTheme(sr.data.dark_mode); } catch (_) {}
        setIsLoggedIn(true);
        // Pass loop param through if specified: /kiosk?B → /?kiosk=1&loop=B
        const params = new URLSearchParams(window.location.search);
        const loopKeys = ["A","B","C","D","E","F"];
        const loopKey = loopKeys.find(k => params.has(k));
        const dest = loopKey ? `/?kiosk=1&loop=${loopKey}` : "/?kiosk=1";
        navigate(dest, { replace: true });
      } catch (e) {
        console.warn("Kiosk login failed:", e.message);
        navigate("/login", { replace: true });
      }
    })();
  }, []); // eslint-disable-line

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", flexDirection: "column", gap: "1rem" }}>
      <img src="/logo.png" alt="CardStoard" style={{ width: 320 }} />
      <p style={{ color: "var(--text-muted)", fontSize: "1.1rem" }}>Starting demo...</p>
    </div>
  );
}
